
AOS.init();
{
  const videoBoxes = document.querySelectorAll(".testi-vid-bx");
  const allVideos = document.querySelectorAll(".testi-vid-bx video");
  function pauseAllVideos(exceptVideo) {
    allVideos.forEach((video) => {
      if (video !== exceptVideo) {
        video.pause();
        const playIcon = video
          .closest(".testi-vid-bx")
          .querySelector(".play-btn-hldr");
        playIcon.style.display = "flex";
      }
    });
  }
  videoBoxes.forEach((box) => {
    const video = box.querySelector("video");
    const playIcon = box.querySelector(".play-btn-hldr");
    box.addEventListener("click", function () {
      if (video.paused) {
        pauseAllVideos(video);
        video.play();
        playIcon.style.display = "none";
      } else {
        video.pause();
        playIcon.style.display = "flex";
      }
    });
    video.addEventListener("play", function () {
      playIcon.style.display = "none";
    });
    video.addEventListener("pause", function () {
      playIcon.style.display = "flex";
    });
  });
}
document.addEventListener("DOMContentLoaded", function () {
    function activateDefaultItem() {
        // Clear previous active items
        document.querySelectorAll(".accordion-item-header").forEach(header => header.classList.remove("active"));
        document.querySelectorAll(".accordion-item-body").forEach(body => body.style.maxHeight = "0");

        const faqCols = document.querySelectorAll(".faqCol");
        const allAccordionItems = document.querySelectorAll(".accordion-item");

        let defaultActiveItem = null;

        if (faqCols.length > 0) {
            if (window.innerWidth < 769) {
                // Mobile: activate from first column
                defaultActiveItem = faqCols[0].querySelector(".accordion-item");
            } else if (faqCols.length > 1) {
                // Desktop: activate from second column
                defaultActiveItem = faqCols[1].querySelector(".accordion-item");
            }
        }

        // Fallback: no faqCol present, or nothing found above
        if (!defaultActiveItem && allAccordionItems.length > 0) {
            defaultActiveItem = allAccordionItems[0];
        }

        // Activate the selected default item
        if (defaultActiveItem) {
            const header = defaultActiveItem.querySelector(".accordion-item-header");
            const body = defaultActiveItem.querySelector(".accordion-item-body");

            if (header && body) {
                header.classList.add("active");
                body.style.maxHeight = body.scrollHeight + "px";
            }
        }
    }

    function setupAccordionClicks() {
        const accordionItems = document.querySelectorAll(".accordion-item");

        accordionItems.forEach(item => {
            const header = item.querySelector(".accordion-item-header");
            const body = item.querySelector(".accordion-item-body");

            header.addEventListener("click", function () {
                const isActive = header.classList.contains("active");

                // Collapse all
                document.querySelectorAll(".accordion-item-header").forEach(h => h.classList.remove("active"));
                document.querySelectorAll(".accordion-item-body").forEach(b => b.style.maxHeight = "0");

                // Toggle current
                if (!isActive) {
                    header.classList.add("active");
                    body.style.maxHeight = body.scrollHeight + "px";
                }
            });
        });
    }

    // Initial run
    activateDefaultItem();
    setupAccordionClicks();

    // On resize
    window.addEventListener("resize", function () {
        activateDefaultItem();
    });
});

{
  document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll(".product_acco_cus_item");
    items.forEach((item) => {
      item.addEventListener("click", () => {
        if (item.classList.contains("open")) {
          item.classList.remove("open");
        } else {
          items.forEach((el) => el.classList.remove("open"));
          item.classList.add("open");
        }
      });
    });
  });
}
